import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 12H18M3 6H21M9 18H15",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFilterIcon;
